import React from 'react';

const TaskIcon = ({ stroke = '#A0A0AB' }: { stroke?: string }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.87759 6.66016H13.8151" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.3851 6.66016L5.9476 7.22266L7.6351 5.53516" fill={stroke} />
    <path
      d="M5.3851 6.66016L5.9476 7.22266L7.6351 5.53516"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.87759 11.9102H13.8151" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.3851 11.9102L5.9476 12.4727L7.6351 10.7852"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3501 16.5H11.8501C15.6001 16.5 17.1001 15 17.1001 11.25V6.75C17.1001 3 15.6001 1.5 11.8501 1.5H7.3501C3.6001 1.5 2.1001 3 2.1001 6.75V11.25C2.1001 15 3.6001 16.5 7.3501 16.5Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaskIcon;
